<template>
  <div class="main-container">
    <CommonHeader></CommonHeader>
    <div class="content-container">
      <router-view></router-view>
    </div>
    <CommonFooter></CommonFooter>
  </div>
</template>

<script>
import CommonHeader from "../components/CommonHeader.vue";
import CommonFooter from "../components/CommonFooter.vue";
export default {
  data() {
    return {
      path: "/Home",
      minHeight: 1080, // 初始最小高度
      minWidth: 1000, // 初始最小宽度
    };
  },
  components: {
    CommonHeader,
    CommonFooter,
  },
  mounted() {
    // 检查是否有待处理的帮助中心跳转
    const targetHelp = localStorage.getItem('targetHelp');
    if (targetHelp) {
      const { menuId, childId } = JSON.parse(targetHelp);
      this.$store.commit("changedMenuId", menuId);
      this.$store.commit("changedLeftChildId", childId);
      this.$router.push("/HelpCentre");
      localStorage.removeItem('targetHelp'); // 清除跳转记录
    } else if (this.$route.path === '/') {
      // 只有在根路径时才跳转到Home
      this.pushHandle(this.path);
    }

    this.updateDimensions(); // 初始化时更新尺寸
  },

  methods: {
    // 切换菜单
    handleSelect(path) {
      this.pushHandle(path);
    },
    pushHandle(path) {
      this.$router.push(path);
    },
    updateDimensions() {
      this.minHeight = window.innerHeight;
      this.minWidth = window.innerWidth;
    },
  },
};
</script>

<style lang="less" scoped>
.main-container {
  min-width: 1000px;
  width: 100%;
  
  .content-container {
    min-width: 1000px;
    width: 100%;
    margin-top: 64px; // 为固定定位的header留出空间
  }
}

/* 整个页面布局使用 flexbox */
.app {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

/* 页面主体内容填充剩余空间 */
.content {
  flex: 1;
  margin-top: 90px; // 为固定的header留出空间
}

/* 固定底部 */
.footer {
  flex-shrink: 0;
}

.el-footer,
el-header {
  padding: 0 !important;
}
</style>
